"use client"
import React, { useRef } from 'react';
import { useNavbarLogic, useDoubleTextLogic } from './navbar.func';
import styles from './Navbar.module.css';
import Link from 'next/link';
import Image from 'next/image';
import gsap from 'gsap';

const DoubleText = ({ text, index, link, onMouseEnter, onMouseLeave, isHovered }) => {
  const { letters } = useDoubleTextLogic(text);

  return (
    <div
      className={styles.doubleTextContainer}
      onMouseEnter={() => onMouseEnter(index)}
      onMouseLeave={() => onMouseLeave(index)}
    >
      <Link href={link}>    <div className={styles.letterWrapper}>
        {letters.map((letter, letterIndex) => (
          <div key={letterIndex} className={styles.letterContainer}>
            <span
              className={styles.letterMain}
              style={{
                transform: isHovered ? 'translateY(-100%)' : 'translateY(0%)',
                transition: `transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)`,
                transitionDelay: isHovered ? `${letterIndex * 0.05}s` : `${(letters.length - letterIndex - 1) * 0.03}s`
              }}
            >
              {letter}
            </span>
            <span
              className={styles.letterDuplicate}
              style={{
                transform: isHovered ? 'translateY(-100%)' : 'translateY(0%)',
                transition: `transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)`,
                transitionDelay: isHovered ? `${letterIndex * 0.05}s` : `${(letters.length - letterIndex - 1) * 0.03}s`
              }}
            >
              {letter}
            </span>
          </div>
        ))}
      </div></Link>
    </div>
  );
};

const Navbar = () => {
  const audioRef = useRef(null);

  const {
    hoverStyle,
    navRef,
    textHover,
    svgHover,
    handleMouseEnter,
    handleTextMouseEnter,
    handleTextMouseLeave,
    handleMouseLeave,
    handleSvgMouseEnter,
    handleSvgMouseLeave
  } = useNavbarLogic();


  return (
    <nav className={styles.navbar} id='navbar'>
      <audio ref={audioRef} src="/print.mp3" preload="auto" />

      <div className={styles.navContent}>
        <div
          ref={navRef}
          className={styles.navLeft}
          onMouseLeave={handleMouseLeave}
        >
          <div
            className={styles.hoverIndicator}
            style={{
              transform: `translateY(-50%) ${hoverStyle.transform}`,
              left: hoverStyle.left,
              opacity: hoverStyle.opacity,
              transition: hoverStyle.transition
            }}
          />
          <DoubleText
            text="HOME"
            index={0}
            link="/"
            onMouseEnter={(index) => {
              handleMouseEnter(index);
              handleTextMouseEnter(index);
            }}
            onMouseLeave={handleTextMouseLeave}
            isHovered={textHover[0]}
          />
          <DoubleText
            text="SHOP"
            index={1}
            link="/shop"
            onMouseEnter={(index) => {
              handleMouseEnter(index);
              handleTextMouseEnter(index);
            }}
            onMouseLeave={handleTextMouseLeave}
            isHovered={textHover[1]}
          />
          <DoubleText
            text="ABOUT"
            index={2}
            link="/about"
            onMouseEnter={(index) => {
              handleMouseEnter(index);
              handleTextMouseEnter(index);
            }}
            onMouseLeave={handleTextMouseLeave}
            isHovered={textHover[2]}
          />
        </div>
        <div
          className={styles.navRight}
          onMouseEnter={handleSvgMouseEnter}
          onMouseLeave={handleSvgMouseLeave}
          onClick={e => {
            if (audioRef.current) {
              audioRef.current.currentTime = 0;
              audioRef.current.play().catch(e => console.log('Audio play failed:', e));
            }
            gsap.timeline().to("#ticketnavbar", { transform: "translateY(50%)", duration: 1 }).to("#ticketnavbar", { transform: "translateY(0%)", duration: 2 })
          }}
          style={{ cursor: 'pointer' }}
        >
          <div
            className={styles.svgBackground}
            style={{
              transform: `translate(-50%, -50%) ${svgHover ? 'scale(1)' : 'scale(0.8)'}`,
              opacity: svgHover ? 1 : 0,
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
            }}
          />
          <div className={styles.svgContainer}>
            <div
              style={{
                position: 'relative',
                width: 'clamp(20px, 2.5vw, 30px)',
                height: 'clamp(20px, 2.5vw, 30px)',
                transform: svgHover ? 'translateX(-100%)' : 'translateX(0%)',
                transition: 'transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)'
              }}
            >
              <Image
                src="/cart.svg"
                alt="Cart"
                fill
                style={{ objectFit: 'contain' }}
                unoptimized
              />
            </div>
            <div
              style={{
                position: 'absolute',
                top: '50%',
                left: '100%',
                width: 'clamp(20px, 2.5vw, 30px)',
                height: 'clamp(20px, 2.5vw, 30px)',
                transform: `translateY(-50%) ${svgHover ? 'translateX(-100%)' : 'translateX(0%)'}`,
                transition: 'transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)'
              }}
            >
              <Image
                src="/cart.svg"
                alt="Cart"
                fill
                style={{ objectFit: 'contain' }}
                unoptimized
              />
            </div>
          </div>
        </div>
      </div>

    </nav>
  );
};

export default Navbar;